import { useState, useCallback, useRef } from "react";
import { chatbotApi } from "../services/chatbotApi";

export function useChatbot() {
  const [messages, setMessages] = useState([]);
  const [sessionId, setSessionId] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const idCounter = useRef(0);

  const nextId = () => String(++idCounter.current);

  const sendMessage = useCallback(
    async (text) => {
      if (!text?.trim() || isLoading) return;

      setError(null);

      const userMsg = {
        id: nextId(),
        role: "user",
        content: text.trim(),
        timestamp: new Date(),
      };

      setMessages((prev) => [...prev, userMsg]);
      setIsLoading(true);

      try {
        const response = await chatbotApi.sendMessage(text.trim(), sessionId);

        if (response?.session_id) {
          setSessionId(response.session_id);
        }

        const assistantMsg = {
          id: nextId(),
          role: "assistant",
          content: response?.answer ?? "",
          timestamp: new Date(),
          ticketCreated: response?.ticket_created,
          ticketId: response?.ticket_id,
        };

        setMessages((prev) => [...prev, assistantMsg]);
      } catch (err) {
        setError("Failed to send message. Please try again.");
        setMessages((prev) => prev.filter((m) => m.id !== userMsg.id));
      } finally {
        setIsLoading(false);
      }
    },
    [isLoading, sessionId]
  );

  const clearSession = useCallback(() => {
    setMessages([]);
    setSessionId(null);
    setError(null);
  }, []);

  return { messages, sessionId, isLoading, error, sendMessage, clearSession };
}

